import { protectedAxios, publicContentAxios } from '@/lib/axiosInstance';
import { ApiResponse } from '@/types/api/common';
import {
  AreaOfInterestResponse,
  CategoryRequest,
  CheckUserNameResponse,
  IndustryResponse,
  OccupationResponse,
  ProfileSetupRequest,
} from '@/types/api/setup-profile';

export const getOccupation = async (): Promise<OccupationResponse> => {
  const response = await protectedAxios.get<OccupationResponse>(
    '/user/occupations?limit=1000'
  );
  return response.data;
};

export const getIndustry = async (): Promise<IndustryResponse> => {
  const response = await protectedAxios.get<IndustryResponse>(
    '/user/industries?limit=1000'
  );
  return response.data;
};

export const getAreaOfInterest = async (): Promise<AreaOfInterestResponse> => {
  const response = await protectedAxios.get<AreaOfInterestResponse>(
    '/user/areas-of-interest'
  );
  return response.data;
};

export const setupProfile = async (
  payload: ProfileSetupRequest
): Promise<ApiResponse<null>> => {
  const response = await protectedAxios.post<ApiResponse<null>>(
    '/user/setup-profile',
    payload
  );
  return response.data;
};

export const checkUserName = async (
  name: string
): Promise<CheckUserNameResponse> => {
  const response = await protectedAxios.get<CheckUserNameResponse>(
    `/user/check-username?username=${name}`
  );
  return response.data;
};

export const getCategories = async (
  payload: CategoryRequest
): Promise<AreaOfInterestResponse> => {
  const response = await publicContentAxios.get<AreaOfInterestResponse>(
    `/categories?type=${payload.type}`
  );
  return response.data;
};
